/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {
	'use strict';

	export enum ScreenMode {
		NoAccess,
		Readonly,
		Edit
	}

	export enum UserRole {
		Provider,
		IndependentAuditor,
		DesignManager,
		None
	}
}